/**
 * The icon for a user or a group. Bare, for a chip's `icon`; inside a circle,
 * see `SubjectAvatar`.
 */
import GroupIcon from '@mui/icons-material/Group';
import PersonIcon from '@mui/icons-material/Person';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { SubjectType } from '@forsys/shared';

export interface SubjectIconProps extends SvgIconProps {
  type: SubjectType;
}

export function SubjectIcon({ type, ...props }: SubjectIconProps) {
  return type === 'group' ? <GroupIcon {...props} /> : <PersonIcon {...props} />;
}
